<template>
  <b-form class="mt-3">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="6">
        <b-form-group label="สถานะจดหมายเชิญ" label-for="statusSelect">
          <vue-select
            label="name"
            value="id"
            v-model="statusSelect"
            :options="statusOptions"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // const options = [
    //   { text: 'ทั้งหมด', value: null },
    //   { text: 'ใช้งาน', value: true },
    //   { text: 'ไม่ใช้งาน', value: false },
    // ]
    const options = [
      { label: "ทั้งหมด", code: null },
      { label: "รอการอนุมัติ", code: 1 },
      { label: "อนุมัติ", code: 2 },
    ];

    const searchList = [
      {
        id: "committeeStatus",
        label: "สถานะจดหมายเชิญ",
        value: "",
        class: "",
        style: "",
        placeholder: "สถานะจดหมายเชิญ",
        type: "select",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      props,
    };
  },
  data() {
    return {
      statusOptions: [
        { name: "ทั้งหมด", id: null },
        { name: "รอการอนุมัติ", id: 1 },
        { name: "อนุมัติ", id: 2 },
      ],
      statusSelect: {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      },
    };
  },
  mounted() {},
  methods: {
    onResetBtnClicked() {
      this.statusSelect = {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      };
      //this.search[1].value=null
      //  this.search[2].value=null
      //  this.search[3].value=null
      //  this.search[4].value=null
      //  this.search[5].value=null
    },
    onSearchBtnClicked() {
      console.log(this.search[0]);
      const params = {
        committeeStatus: this.statusSelect?.id,
      };

      //console.log('onSearchBtnClicked', params)

      this.$emit("handleSubmit", params);
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
